<template lang="pug">
.jumbotron.jumbotron-fluid.text-white.bg-dark.mb-0(
  v-if="banner.photo",
  :style="{ backgroundImage: 'url(' + banner.photo.image + ')' }"
)
  .container.d-flex.justify-content-center
    .d-flex.justify-content-between.align-items-center.col-md-10
      .title
        h4.display-4.text-white.mb-0 {{ banner.company_title }}
      .user-box
        h3 {{ banner.ir_head_title }}
        h4 {{ banner.ir_head_name }}
        p.mb-0 {{ banner.ir_head_desc }}
        a(:href="'mailto:' + banner.ir_head_email") {{ banner.ir_head_email }}
</template>

<script>
export default {
  name: "Banner",
  props: {
    banner: Object,
  },
};
</script>

<style lang="scss" scoped>
.user-box {
  width: 200px;
  border: 2px white solid;
  padding: 1.5rem 1rem;

  h3 {
    color: white;
    margin-bottom: 0;
    font-size: 1.2rem;
  }

  h4 {
    color: white;
    margin-bottom: 0;
    font-size: 1rem;
  }

  a {
    color: white;
    text-decoration: underline;
  }
}

@media only screen and (max-width: 959px) {
  .jumbotron .display-4 {
    font-size: 2rem;
  }
}
</style>
